<template>
  <v-row justify="center">
    <v-col cols="12" class="py-0">
      <v-row justify="center" align="stretch">
        <v-col md="4" class="d-flex flex-column">
          <v-img class="align-self-center" contain :src="require('assets/static/img/logo/quickcash.png')"></v-img>
          <upcoming-sortition
            id="upcoming-result"
            :upcoming-sortition="upcomingSortition"
            @refresh="fetchUpcomingSortition"
          ></upcoming-sortition>
          <div class="card-header"><span>Pick</span> <span>Numbers</span></div>
          <result-display
            v-for="result in results.entries.slice(0, 1)"
            :key="result.sortition.id"
            :result="result"
          >
          </result-display>
          <br />
        </v-col>
        <v-col
          md="4"
          class="d-flex flex-column"
          v-if="results.entries.slice(1).length > 0"
        >
          <div class="card-header"><span>Pick</span> <span>Numbers</span></div>
          <result-display
            v-for="result in results.entries.slice(1)"
            :key="result.sortition.id"
            :result="result"
          >
          </result-display>
        </v-col>
        <v-col md="4" class="d-flex flex-column playouts-card">
          <!-- Playouts card -->
					<div class="card-header">
            <span v-if="showPrizes">
            Payouts
            </span>
						<span v-else>
							Results
						</span>
					</div>
					<prizes-card
						v-if="showPrizes"
						:prizes="prizes"></prizes-card>
					<results-card
						class="card-results"
						v-if="showResults"
						display-horizontally
						:results-by-lottery="resultsToShow"></results-card>
				</v-col>
      </v-row>
    </v-col>
    <v-col id="page-url" cols="12" class="text-center py-0">
      <span>Visit our page {{ url }}</span>
    </v-col>
  </v-row>
</template>

<script>
import ResultDisplay from "./ResultDisplay.vue";
import UpcomingSortition from "./UpcomingSortition.vue";
import BaseBoard from "../BaseBoard.js";
import PrizesCard from "./PrizesCard.vue";
import ResultsCard from '../../common/ResultsCard.vue';

export default {
  name: "Board",
  extends: BaseBoard,
  components: {
		ResultsCard,
    UpcomingSortition,
    ResultDisplay,
    PrizesCard
  }
};
</script>

<style scoped lang="scss">
@import "css/variables";
$card-background: rgba(#2b55bc, 0.5);
.result-display {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.v-card {
  background-color: darken($card-background, 20);
  color: white;
  border-radius: 30px;

  &:not(#primary-card) {
    box-shadow: 8px 6px 20px 0 #07000080;
  }
}

#primary-card {
  background-color: transparent;
  border: 2px solid white;
}

::v-deep .v-card #countdown {
  line-height: 30px;
  text-align: center;
  font-family: "Made Tommy Outline", serif;
}

#winning-numbers-text {
  line-height: 20px;
  color: $green;
}

#upcoming-sortition {
  margin-top: 10px;
  margin-bottom: 10px;
}

.card-header {
  box-shadow: -3px 3px 7px 0px #0000009e;
  font-size: 1.5rem;
  padding: 0 6px;
  margin-bottom: 5px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-radius: 30px;
  background-image: linear-gradient(to right, $green, #016d33);
}
.playouts-card {
  border: solid $green 2px;
	border-radius: 30px;
  height: 100%;
}

#page-url {
	padding-top: 0;
	span {
      font-size: 2rem;
      color: #f26522;
    }
}

::v-deep .card-results * {
	color: #f26522;
}
</style>
